import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.nameInput = this.element.querySelector("#organization_name")
    this.codePrefixInput = this.element.querySelector("#organization_code_prefix")
    this.codePrefixManuallyEdited = this.codePrefixInput?.value.trim().length > 0

    this.parentToggle = this.element.querySelector("#organization_parent_organization")
    this.childrenSelect = this.element.querySelector("#organization_children")
    this.childrenWrapper = this.childrenSelect?.closest("[data-controller~='multiselect']")
    this.childrenLabel = this.childrenWrapper?.previousElementSibling

    this.parentIdSelect = this.element.querySelector("#organization_parent_id")
    this.parentIdWrapper = this.parentIdSelect?.closest("[data-controller~='multiselect']")
    this.parentIdLabel = this.parentIdWrapper?.previousElementSibling

    this.boundSyncVisibility = this.syncVisibility.bind(this)
    this.boundSyncCodePrefix = this.syncCodePrefix.bind(this)
    this.boundMarkCodePrefixEdited = this.markCodePrefixEdited.bind(this)

    this.parentToggle?.addEventListener("change", this.boundSyncVisibility)
    this.nameInput?.addEventListener("input", this.boundSyncCodePrefix)
    this.codePrefixInput?.addEventListener("input", this.boundMarkCodePrefixEdited)

    this.syncCodePrefix()
    this.syncVisibility()
  }

  disconnect() {
    if (this.parentToggle && this.boundSyncVisibility) {
      this.parentToggle.removeEventListener("change", this.boundSyncVisibility)
    }

    if (this.nameInput && this.boundSyncCodePrefix) {
      this.nameInput.removeEventListener("input", this.boundSyncCodePrefix)
    }

    if (this.codePrefixInput && this.boundMarkCodePrefixEdited) {
      this.codePrefixInput.removeEventListener("input", this.boundMarkCodePrefixEdited)
    }
  }

  syncCodePrefix() {
    if (!this.nameInput || !this.codePrefixInput || this.codePrefixManuallyEdited) return

    this.codePrefixInput.value = this.slugify(this.nameInput.value)
  }

  markCodePrefixEdited() {
    this.codePrefixManuallyEdited = true
  }

  slugify(value) {
    return value
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  }

  syncVisibility() {
    const isParentOrg = this.parentToggle?.checked

    // Show children field only when parent_organization is checked
    if (this.childrenSelect && this.childrenWrapper && this.childrenLabel) {
      this.childrenLabel.classList.toggle("hidden", !isParentOrg)
      this.childrenWrapper.classList.toggle("hidden", !isParentOrg)
      this.childrenSelect.disabled = !isParentOrg

      if (this.childrenWrapper.choicesInstance) {
        if (isParentOrg) {
          this.childrenWrapper.choicesInstance.enable()
        } else {
          this.childrenWrapper.choicesInstance.disable()
        }
      }
    }

    // Show parent_id field only when parent_organization is NOT checked
    if (this.parentIdSelect && this.parentIdWrapper) {
      this.parentIdWrapper.classList.toggle("hidden", isParentOrg)
      if (this.parentIdLabel) {
        this.parentIdLabel.classList.toggle("hidden", isParentOrg)
      }
      this.parentIdSelect.disabled = isParentOrg

      if (this.parentIdWrapper.choicesInstance) {
        if (isParentOrg) {
          this.parentIdWrapper.choicesInstance.disable()
        } else {
          this.parentIdWrapper.choicesInstance.enable()
        }
      }
    }
  }
}
